export const formatSalesValue = (value) => {
    if (value === 0) return '-'; // Return '-' for zero values
    return new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);
};
